import Vue from "vue";
import "@mdi/font/css/materialdesignicons.css";
import Vuetify from "vuetify/lib/framework";

import { TiptapVuetifyPlugin } from "tiptap-vuetify";
// don't forget to import CSS styles
import "tiptap-vuetify/dist/main.css";

const vuetify = new Vuetify();

Vue.use(Vuetify);

Vue.use(TiptapVuetifyPlugin, {
    // the next line is important! You need to provide the Vuetify Object to this place.
    vuetify, // same as "vuetify: vuetify"
    // optional, default to 'md' (default vuetify icons before v2.0.0)
    iconsGroup: "mdi",
});

export const DARK_MODE_STORAGE_KEY = "resPecDarkMode";

let isDarkMode = false;
try {
    isDarkMode = window.localStorage.getItem(DARK_MODE_STORAGE_KEY) === "true";
} catch (e) {
    isDarkMode = false;
}

export default new Vuetify({
    theme: {
        dark: isDarkMode,
        options: { customProperties: true },
        themes: {
            light: {
                primary: "#1f3a5f",
                secondary: "#2ec4b6",
                accent: "#f59e0b",
                error: "#F44336",
                info: "#5a6b85",
                success: "#22c55e",
                warning: "#f59e0b",
                purple: "#aec8d2",
                gray: "#111827",
                darkGreen: "#00C198",
                bgColor: "#f5f7fd",
            },
            dark: {
                primary: "#1e3557",
                secondary: "#20D3AA",
                accent: "#3a3a3a",
                error: "#F44336",
                info: "#202427",
                success: "#00AC7C",
                warning: "#FFC107",
                purple: "#aec8d2",
                gray: "#292e32",
                darkGreen: "#00C198",
                bgColor: "#12161f",
            },
        },
    },
    icons: {
        iconfont: "mdi", // default - only for display purposes
    },
});
